function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import logoSm from '../../assets/images/logo_sm.png';
import logoDark from '../../assets/images/logo-dark.png';
import logoDarkSm from '../../assets/images/logo_sm_dark.png';
import logo from '../../assets/images/logo.png';
import helpBoxImage from '../../assets/images/help-icon.svg';
import profileImg from '../../assets/images/users/avatar-1.jpg';
import AppMenu from './AppMenu';

const SideBarContent = ({
  hideUserProfile,
  isLight,
  menuClickHandler
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideUserProfile && /*#__PURE__*/React.createElement("div", {
    className: "leftbar-user"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: profileImg,
    alt: "",
    height: "42",
    className: "rounded-circle shadow-sm"
  }), /*#__PURE__*/React.createElement("span", {
    className: "leftbar-user-name"
  }, "Dominic Keller"))), /*#__PURE__*/React.createElement(AppMenu, {
    menuClickHandler: menuClickHandler
  }), /*#__PURE__*/React.createElement("div", {
    className: "help-box text-white text-center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: "float-right close-btn text-white"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-close"
  })), /*#__PURE__*/React.createElement("img", {
    src: helpBoxImage,
    height: "90",
    alt: "Helper Icon"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "mt-3"
  }, "Unlimited Access"), /*#__PURE__*/React.createElement("p", {
    className: "mb-3"
  }, "Upgrade to plan to get access to unlimited reports"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-outline-light btn-sm"
  }, "Upgrade")), /*#__PURE__*/React.createElement("div", {
    className: "clearfix"
  }));
};

class LeftSidebar extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "menuNodeRef", void 0);

    _defineProperty(this, "componentDidMount", () => {
      document.addEventListener('mousedown', this.handleOtherClick, false);
    });

    _defineProperty(this, "componentWillUnmount", () => {
      document.removeEventListener('mousedown', this.handleOtherClick, false);
    });

    _defineProperty(this, "handleOtherClick", e => {
      if (this.menuNodeRef.contains(e.target)) return; // else hide the menubar

      if (document.body) {
        document.body.classList.remove('sidebar-enable');
      }
    });

    this.handleClick = this.handleClick.bind(this);
    this.handleOtherClick = this.handleOtherClick.bind(this);
  }
  /**
   * Bind event
   */


  /**
   * Handle click
   * @param {*} e
   * @param {*} item
   */

  /*:: handleClick: () => void */
  handleClick(e) {
    console.log(e);
  }

  render() {
    const isCondensed = this.props.isCondensed || false;
    const isLight = this.props.isLight || false;
    const hideLogo = this.props.hideLogo || false;
    const hideUserProfile = this.props.hideUserProfile || false;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "left-side-menu",
      ref: node => this.menuNodeRef = node
    }, !hideLogo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      to: "/",
      className: "logo text-center logo-light"
    }, /*#__PURE__*/React.createElement("span", {
      className: "logo-lg"
    }, /*#__PURE__*/React.createElement("img", {
      src: isLight ? logoDark : logo,
      alt: "logo",
      height: "16"
    })), /*#__PURE__*/React.createElement("span", {
      className: "logo-sm"
    }, /*#__PURE__*/React.createElement("img", {
      src: isLight ? logoSm : logoDarkSm,
      alt: "logo",
      height: "16"
    }))), /*#__PURE__*/React.createElement(Link, {
      to: "/",
      className: "logo text-center logo-dark"
    }, /*#__PURE__*/React.createElement("span", {
      className: "logo-lg"
    }, /*#__PURE__*/React.createElement("img", {
      src: isLight ? logoDark : logo,
      alt: "logo",
      height: "16"
    })), /*#__PURE__*/React.createElement("span", {
      className: "logo-sm"
    }, /*#__PURE__*/React.createElement("img", {
      src: isLight ? logoSm : logoDarkSm,
      alt: "logo",
      height: "16"
    })))), !isCondensed && /*#__PURE__*/React.createElement(SimpleBar, {
      style: {
        maxHeight: '100%'
      },
      timeout: 500,
      scrollbarMaxSize: 320
    }, /*#__PURE__*/React.createElement(SideBarContent, {
      menuClickHandler: this.handleClick,
      isLight: isLight,
      hideUserProfile: hideUserProfile
    })), isCondensed && /*#__PURE__*/React.createElement(SideBarContent, {
      isLight: isLight,
      hideUserProfile: hideUserProfile
    })));
  }

}

export default LeftSidebar;